export default "__VITE_ASSET__nbqXbY3S__"